// Screen definition: Clientes
// Server-side pagination
import type { ScreenDefinition } from '@/types/screen-definition';

export const clienteScreenDef: ScreenDefinition = {
  id: 'clientes',
  title: 'Clientes',
  itemLabel: 'clientes',

  columns: [
    {
      key: 'nombre',
      header: 'Cliente',
      type: 'custom', // Avatar + Link combo
      locked: true,
    },
    {
      key: 'codigo',
      header: 'Código',
      type: 'text',
      config: { mono: true },
    },
    {
      key: 'modo_operacion',
      header: 'Modo',
      type: 'badge',
      config: {
        labelMap: { SIMPLE: 'Simple', ESTANDAR: 'Estándar', CORPORATIVO: 'Corporativo' },
        variantMap: { SIMPLE: 'outline', ESTANDAR: 'default', CORPORATIVO: 'secondary' },
      },
    },
    {
      key: 'activo',
      header: 'Estado',
      type: 'badge',
      config: {
        labelMap: { true: 'Activo', false: 'Inactivo' },
        variantMap: { true: 'success', false: 'secondary' },
      },
    },
  ],

  defaultSort: { field: 'nombre', order: 'asc' },

  pagination: {
    mode: 'server',
    defaultPageSize: 25,
  },

  search: {
    enabled: true,
    placeholder: 'Buscar clientes...',
  },

  filterSections: [
    {
      key: 'general',
      title: 'General',
      filters: [
        {
          key: 'activo',
          label: 'Estado',
          type: 'select',
          options: [
            { value: 'true', label: 'Activo' },
            { value: 'false', label: 'Inactivo' },
          ],
        },
      ],
    },
  ],

  rowClick: { type: 'navigate', path: '/clientes/:id' },

  rowActions: [
    { label: 'Ver detalle', icon: 'Eye', action: 'navigate' },
    { label: 'Editar', icon: 'Pencil', action: 'edit' },
    { label: 'Eliminar', icon: 'Trash2', action: 'delete', variant: 'destructive' },
  ],

  empty: {
    message: 'No se encontraron clientes',
    icon: 'Users',
  },
};
